// vim: set ts=2 sts=2 sw=2 et:
//
// This file is part of OpenLifter, simple Powerlifting meet software.
// Copyright (C) 2019 The OpenPowerlifting Project.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU Affero General Public License as
// published by the Free Software Foundation, either version 3 of the
// License, or (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU Affero General Public License for more details.
//
// You should have received a copy of the GNU Affero General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.

import React from "react";
import { connect } from "react-redux";

import FlightDetailsBare, { SessionPlatformFlight } from "./FlightDetailsBare";

import { Entry, Flight, Language } from "../../types/dataTypes";
import { GlobalState, MeetState, LiftingState, ServerState, RegistrationState } from "../../types/stateTypes";

import styles from "./ObsFlightDetails.module.scss";
import DataTable, { BACKGROUNDCOLOR, getTitleWidth, TableEntry } from "../overlays/DataTable";
import { getTableData } from "../../logic/config";
import { getEntriesInFlight } from "../../logic/liftingOrder";

interface StateProps {
  meet: MeetState;
  lifting: ReadonlyArray<LiftingState>;
  entries: ReadonlyArray<Entry>;
  language: Language;
  server: ServerState;
}

interface OwnProps {
  currentOnly: boolean;
}

type Props = StateProps;

class ObsFlightDetailsBare extends React.Component<Props> {

  render() {

    // default to day on first platform (should be the same...)
    const lifting = this.props.lifting[0];
    const day = lifting.day;
    const entries = this.props.entries;

    const numPlatforms = this.props.meet.platformsOnDays[day - 1]
    const onlyPlatform = numPlatforms === 1
    const entriesInFlights = []
    const spf: SessionPlatformFlight[] = []
    for (let i = 1; i <= numPlatforms; i++) {
      const lifting = this.props.lifting[i-1];
      const session = lifting.session
      const platform = lifting.platform;
      const flight = lifting.flight;
      const entriesInFlight = getEntriesInFlight(day, session, platform, flight, entries);
      entriesInFlights.push(...entriesInFlight)
      spf.push(
        {
          session: session,
          platform: platform,
          flight: flight,
        }
      )
    }

    let flightDetails = []
      if (entriesInFlights.length > 0) {
        flightDetails.push(
          <FlightDetailsBare onlyPlatform={onlyPlatform} day={day} session={0} platform={0} knownFlights={[]} shownEntries={entriesInFlights} sessionPlatformFlights={spf} lifting={lifting} scale={1} bare={true}/>
        )
      } else {
        flightDetails.push(
          <></>
        )
      }

    return (
      <div>
        <div id="obsFlightDetailsView" className={styles.liftingView}>
          <div style={{minHeight: "100%", fontSize: 'calc((1vw + 1vh)*' + 1 + ')'}}>
            {flightDetails}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: GlobalState): StateProps => {
  return {
    meet: state.meet,
    lifting: state.lifting,
    entries: state.registration.entries,
    language: state.language,
    server: state.server,
  };
};

export default connect(mapStateToProps)(ObsFlightDetailsBare);

